"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneOffPickupRequestUpdate = exports.OneOffPickupRequestResolutionEmbeddedCreate = exports.OneOffPickupRequestCreate = exports.OneOffPickupRequestQuery = exports.OneOffPickupRequestPrimaryTransport = exports.OneOffPickupRequestTransport = exports.OneOffPickupRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const CommercialSubscription_1 = require("../subscriptions-and-billing/CommercialSubscription");
const SubscriptionEquipment_1 = require("../subscriptions-and-billing/SubscriptionEquipment");
exports.OneOffPickupRequest = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    subscription: CommercialSubscription_1.CommercialSubscription,
    equipment: SubscriptionEquipment_1.SubscriptionEquipment,
    // routePlanStop: Type.Optional(RoutePlanStop),
    routePlanStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid', description: 'This is the RoutePlanStop that will be servicing this request.' })),
    forFailedStopID: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'uuid',
        description: 'If this one-off request is because of a failed pickup, this will point at the RoutePlanStop that failed.',
    })),
    resolvesEventID: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'uuid',
        description: 'If this one-off request is being created to resolve an event, this will point at that RouteEvent.',
    })),
    metadata: common_1.MetaData,
});
exports.OneOffPickupRequestTransport = exports.OneOffPickupRequest;
exports.OneOffPickupRequestPrimaryTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.OneOffPickupRequest, ['routePlanStopID', 'forFailedStopID', 'resolvesEventID']),
    typebox_1.Type.Object({
        routePlanStop: typebox_1.Type.Optional(typebox_1.Type.Any()),
        forFailedStop: typebox_1.Type.Optional(typebox_1.Type.Any()),
        resolvesEvent: typebox_1.Type.Optional(typebox_1.Type.Any()),
    }),
]);
exports.OneOffPickupRequestQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
        equipmentID: typebox_1.Type.String({ format: 'uuid' }),
        hasRoutePlanStop: typebox_1.Type.Boolean(),
        routePlanStopID: typebox_1.Type.String({ format: 'uuid' }),
        hasFailedStop: typebox_1.Type.Boolean(),
        forFailedStopID: typebox_1.Type.String({ format: 'uuid' }),
        hasEvent: typebox_1.Type.Boolean(),
        resolvesEventID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.OneOffPickupRequestCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.OneOffPickupRequest, ['id', 'haulerID', 'subscription', 'equipment', 'metadata']),
    typebox_1.Type.Object({
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
        equipmentID: typebox_1.Type.String({ format: 'uuid' }),
        createStopNow: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
exports.OneOffPickupRequestResolutionEmbeddedCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.OneOffPickupRequestCreate, ['routePlanStopID', 'forFailedStopID', 'resolvesEventID']),
    typebox_1.Type.Object({ stopType: typebox_1.Type.Optional(enums_1.StopType), numStops: typebox_1.Type.Optional(typebox_1.Type.Number()) }),
]);
exports.OneOffPickupRequestUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.OneOffPickupRequest, [
        'id',
        'haulerID',
        'subscription',
        'equipment',
        'routePlanStopID',
        'forFailedStopID',
        'resolvesEventID',
        'metadata',
    ]),
    typebox_1.Type.Object({
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
        equipmentID: typebox_1.Type.String({ format: 'uuid' }),
        routePlanStopID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
        forFailedStopID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
        resolvesEventID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    }),
]));
//# sourceMappingURL=OneOffPickupRequest.js.map